import { ChangeEvent, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Agent, SuperVisor, Ticket } from '@/types';
import { ChatboxReply, ChatboxReplyHead, ChatheadEmail, ChatHeadBottom, ReplyTextarea, ChatboxReplyFooter, } from '@/components/UI/styles/TicketDetails.Conversations.styled';
import { Box, Typography, FormControl, Avatar } from "@mui/material";
import { AppButton, AppSelectField, AppTextField } from '@/components';
import { useParams } from 'react-router-dom';
import CustomerService from '@/services/Customer.Service';
import { toast } from 'react-toastify';

const replyOptions = [
    { value: "1", label: "Reply", },
];

interface Props {
    setTicketDetails: React.Dispatch<React.SetStateAction<Ticket | null>>;
    ticketDetails: Ticket | null;
    supportEmail?: string;
}

const CustomerTicketDetailsEmailReply: React.FC<Props> = ({ ticketDetails, supportEmail, setTicketDetails }) => {
    const user: Agent | SuperVisor | null = useAuth();
    const { id } = useParams();

    console.log(ticketDetails, "ticketDetails");

    const [formData, setFormData] = useState({
        emailBody: '',
    });
    const [sendingReply, setSendingReply] = useState(false);

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const sendMailToCustomer = async () => {
        // // if (!isAssignedToMe()) return
        // try {
        //     const { data } = await TicketService.sendMailToCustomer({
        //         ticket_id: id,
        //         emailBody,
        //         id
        //     });
        //     setFormData(prev => ({ ...prev, emailBody: '' }))
        //     setTicketDetails(prev => ({ ...prev!, conversations: [...prev?.conversations!, data] }))
        // } catch (error) {
        //     console.error('Error:', error);
        // }
        
        if (!formData.emailBody || formData.emailBody.trim() === '') {
            toast.error('Please enter a message before submit');
            return;
        }
        setSendingReply(true);
        try {
            const payload = { message: formData.emailBody };
            const res = await CustomerService.submitTicket(payload, Number(ticketDetails?.id));
            setFormData(prev => ({ ...prev, emailBody: '' }));
            setTicketDetails(prev => ({ ...prev!, conversations: [...(prev?.conversations ?? []), res?.data] }));
        } finally {
            setSendingReply(false);
        }
    }

    return (
        <>
            <ChatboxReply>
                <ChatboxReplyHead>
                    <Avatar
                        alt={user?.userName || "User"}
                        src="/images/static/user-photo5.png"
                        sx={{ width: 28, height: 28 }}
                    />
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', ml: 1.25 }}>
                        <img src="/images/reply-icon.svg" alt="" />
                        <FormControl className="v2">
                            <AppSelectField
                                label=""
                                name=""
                                options={replyOptions}
                                defaultValue={1}
                            />
                        </FormControl>
                    </Box>
                    <ChatheadEmail>From: <Typography> {user?.email || 'Customer email not available'} </Typography></ChatheadEmail>
                </ChatboxReplyHead>
                <ChatHeadBottom>
                    <ChatheadEmail className="noGap">To: <Typography> {supportEmail || 'Support email set up is pending'} </Typography></ChatheadEmail>
                </ChatHeadBottom>
                <ReplyTextarea>
                    <FormControl fullWidth>
                        <AppTextField
                            name="emailBody"
                            value={formData.emailBody}
                            label=""
                            onChange={handleChange}
                            multiline
                            placeholder="Type here..."
                            disabled={sendingReply}
                            InputLabelProps={{ shrink: true }}
                        />
                    </FormControl>
                </ReplyTextarea>
                <ChatboxReplyFooter>
                    <AppButton
                        disabled={!supportEmail || sendingReply}
                        loading={sendingReply}
                        loadingText="Sending reply..."
                        onClick={sendMailToCustomer}
                        disableElevation
                        variant="contained"
                        sx={{ ml: 'auto', minWidth: '100px !important' }}
                    >
                        Submit
                    </AppButton>
                </ChatboxReplyFooter>
            </ChatboxReply>
        </>
    );
}

export default CustomerTicketDetailsEmailReply;
